import React from "react";
import styles from "./Help.module.scss";

interface HelpLayoutProps {
    children: React.ReactNode;
    title?: string;
}

function HelpLayout({ children, title = "Help" }: HelpLayoutProps) {
    return (
        <div className={styles.helpContainer}>
            <div className={styles.helpHeader}>
                <h1 className="medium">{title}</h1>
            </div>
            <div className={styles.helpContent}>{children}</div>
        </div>
    );
}

export default HelpLayout;
